import {
  GET_CHECKOUT,
  SET_CHECKOUT,
  REMOVE_CHECKOUT,
  CHECKOUT_ERROR,
} from "../actions/types";

const initialState = {
  data: {},
  loading: true,
  error: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CHECKOUT:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SET_CHECKOUT:
      return;
    case REMOVE_CHECKOUT:
      return { ...state, data: {}, loading: false };

    case CHECKOUT_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
